import { LogOut } from "lucide-react";
import { Button } from "@/components/ui/Button";
import { Card } from "@/components/ui/Card";
import { SettingsSection } from "@/components/ui/SettingsSection";
import { SettingsRow } from "@/components/ui/SettingsRow";
import { useAuth } from "@/app/AuthContext";
import { displayUserName, userInitials } from "@/lib/userName";

export function AccountScreen() {
  const { user, logout } = useAuth();

  return (
    <div className="mx-auto flex max-w-[640px] flex-col gap-8 p-8 max-md:p-4">
      <h1 className="text-2xl font-semibold tracking-tight">Account</h1>

      <Card className="flex items-center gap-4 p-5">
        <div
          className="flex h-14 w-14 shrink-0 items-center justify-center rounded-full
                     bg-podpink-500 text-lg font-semibold text-white"
        >
          {userInitials(user)}
        </div>
        <div className="min-w-0">
          <div className="truncate text-lg font-semibold">{displayUserName(user)}</div>
          {user?.email !== undefined && (
            <div className="mt-0.5 truncate text-sm text-text-muted">{user.email}</div>
          )}
        </div>
      </Card>

      <SettingsSection title="Profile">
        <SettingsRow label="Full name">
          <span className="text-sm text-text-muted">{user?.name ?? "—"}</span>
        </SettingsRow>
        <SettingsRow label="Email">
          <span className="truncate text-sm text-text-muted">{user?.email ?? "—"}</span>
        </SettingsRow>
        {/* Groups, not the roles they grant: a role is an endpoint name and an account holds
            dozens of them, which told the reader nothing and filled the screen. */}
        <SettingsRow
          label={user !== null && user.groups.length === 1 ? "Group" : "Groups"}
          description="Cognito group affiliations">
          <span className="text-right text-sm break-words text-text-muted">
            {user !== null && user.groups.length > 0 ? user.groups.join(", ") : "—"}
          </span>
        </SettingsRow>
      </SettingsSection>

      <Button
        className="flex items-center gap-2 self-start border-danger bg-red-50 text-danger
                   hover:bg-red-25"
        onClick={() => void logout()}
      >
        <LogOut className="h-4 w-4" aria-hidden />
        Log out
      </Button>
    </div>
  );
}
